import { getColorValue } from '../lib/utils';

import type { IconProps } from '.';

export const MessageStar = ({ bgColor = 'illustration-line', fgColor = 'illustration-face', size = 48 }: IconProps) => {
  const bgHsl = getColorValue(bgColor);
  const fgHsl = getColorValue(fgColor);

  return (
    <svg fill="none" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
      <path
        fill={bgHsl}
        d="M61.5 22.3C58 9.6 39.4 4.9 24.6 8.6 20 9.8 15.6 12 12.2 15l-.3.2c-.8.7-5.2 5.7-5.8 6.4a17.7 17.7 0 0 0-3.4 16.6c1.5 6 7 9 10.2 10.4a34 34 0 0 0 5.8 1.8c1 2.2.8 4.1-.7 6.6-.2.3-.3.7-.1 1 .1.4.4.7.8.8a8.2 8.2 0 0 0 4.5 0 17 17 0 0 0 11.3-8.3c.7 0 1.4-.2 2.1-.4 4.3-1 9.8-2.6 14.3-6 1.2-.9 7.5-5.7 9.2-9.8 2-3.3 2.3-8.5 1.3-12Z"
      />
      <path
        fill={fgHsl}
        d="M25.2 11c-4.7 1.2-19.6 6.3-15.8 21.8 1.3 5 6.1 7.6 8.9 8.7 1.9.8 4 1.4 6 1.8.5.1.8.4 1 .9.7 2.9.3 5.8-1 8.2.8.1 1.7 0 2.6-.2 2.8-.8 7.6-3.8 9-7.8.2-.4.6-.8 1-.8a41 41 0 0 0 3.6-.7c6.1-1.4 13.7-3.9 17.5-9.8 1.7-2.6 2-7.2 1.1-10.2-3-11.4-20.2-15.4-33.9-12Z"
      />
      <path
        fill={bgHsl}
        d="M46.2 26.4c-.2-.4-.5-.7-.9-.8-9.2-2.3-9.4-3.9-10-9.1v-.8c-.1-.6-.6-1.1-1.2-1.1-.7 0-1.1.4-1.2 1-1.3 7-4 9.7-9.9 9.8-.5 0-1 .4-1.1 1-.1.5.2 1 .8 1.3l2.6.7c1.8.5 3.9 1 4.9 1.8 1.2 1 2.1 4.8 2.4 7.8 0 .6.6 1 1.2 1s1.2-.4 1.2-1c.7-7.8 5.6-8.8 8.5-9.4 1.2-.2 2.1-.4 2.6-1.2a1 1 0 0 0 0-1Z"
      />
    </svg>
  );
};
